import { formatMinutesToHours } from "../../components/DashboardHomeView";
import { type CongesDashboardSummary, getCampagnesCp } from "../types";
import { LeaveBalanceCard } from "./LeaveBalanceCard";

interface CongesMetricsRowProps {
  data?: CongesDashboardSummary;
}

export function CongesMetricsRow({ data }: CongesMetricsRowProps) {
  const campagnesCp = getCampagnesCp(data);
  const cpCards = campagnesCp.length;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 animate-fade-in">
      {cpCards > 0 ? (
        campagnesCp.map((campagne, index) => (
          <LeaveBalanceCard
            key={campagne.periodeDebut}
            title="Congés Payés"
            used={campagne.utilises}
            total={campagne.total}
            color="info"
            year={campagne.annee}
            className="animate-slide-in-left"
            style={{ animationDelay: `${index * 50}ms` }}
          />
        ))
      ) : (
        <LeaveBalanceCard
          title="Congés Payés"
          used={data?.utilisesCongesPayes ?? 0}
          total={data?.totalCongesPayes ?? 25}
          color="info"
          year={data?.anneeCongesPayes}
          className="animate-slide-in-left"
          style={{ animationDelay: "0ms" }}
        />
      )}
      <LeaveBalanceCard
        title="RTT"
        used={data?.utilisesRTT ?? 0}
        total={data?.totalRTT ?? 10}
        color="success"
        year={data?.anneeRTT}
        className="animate-slide-in-left"
        style={{ animationDelay: `${Math.max(cpCards, 1) * 50}ms` }}
      />
      <LeaveBalanceCard
        title="Heures Sup"
        used={data?.utilisesHeuresSup ?? 0}
        total={data?.totalHeuresSup ?? 0}
        color="warning"
        unit="heures"
        formatValue={formatMinutesToHours}
        className="animate-slide-in-left"
        style={{ animationDelay: `${(Math.max(cpCards, 1) + 1) * 50}ms` }}
      />
    </div>
  );
}
